<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/myAccountList/">My Accounts</a></li>
      <li class="breadcrumb-item active" aria-current="page">Edit User</li>
    </ol>
  </nav>
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black mb-3"> User Details</h2>
          <div class="row mt-3">
            <div class="col-md-12 col-md-8">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group required">
                    <label class="control-label" for="firstName">First Name</label>
                    <input type="text" id="firstName" [(ngModel)]="edituser.firstName"
                           [ngModelOptions]="{standalone: true}" class="form-control" (blur)="typeFirstName()" [ngClass]="{'is-invalid':statusText1}"
                           onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32"
                           autocomplete="off" required>
                    <div id="statusText1" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText1">{{statusText1}}</div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group required">
                    <label class="control-label" for="lastName">Last Name</label>
                    <input type="text" id="lastName" [(ngModel)]="edituser.lastName"
                           [ngModelOptions]="{standalone: true}" class="form-control" (blur)="typeLastName()" [ngClass]="{'is-invalid':statusText2}"
                           onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32"
                           autocomplete="off" required>
                    <div id="statusText2" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText2">{{statusText2}}</div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group required">
                    <label class="control-label" for="contactNumber">Phone Number</label>
                    <input type="text" id="contactNumber"
                           onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                           [(ngModel)]="edituser.mobile" [ngModelOptions]="{standalone: true}" maxlength="10"
                           class="form-control"  (blur)="typeMobile()"  [ngClass]="{'is-invalid':statusText3}"  required>
                    <div id="statusText3" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText3">{{statusText3}}</div>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group required">
                    <label class="control-label" for="email">Email</label>
                    <input type="text" id="email" [(ngModel)]="edituser.email" [ngModelOptions]="{standalone: true}"
                           class="form-control" (blur)="typeEmail()" [ngClass]="{'is-invalid':statusText4}"  required>
                    <div id="statusText4" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText4">{{statusText4}}</div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <!--<div class="row mt-3">
            <div class="col-12 text-right">
              <button type="reset" routerLink="/admin/myAccountList" class="btn btn-cancel">Cancel</button>
              <button type="submit" (click)="editUser()" class="btn btn-orange ml-2">Save</button>
            </div>
          </div>-->

        </div>
        <div class="row">
          <div class="col-6 px-0">
            <div class="d-block mt-2" *ngFor="let role of groupList | slice:0: sliceUPto(groupList?.length)-1;let i = index;">
              <div class="col">
                <div class="inner-box">
                  <h2 class="text-black">{{role.groupDescription}}</h2>
                  <hr class="mt-1 mb-2">
                  <div class="row align-items-center " *ngIf="['outbound_orders','inventory','work_orders','inbound_orders'].indexOf(role.groupCode)>-1">
                    <div class="col-lg-3 col-md-5 col-sm-5 text-center">
<!--                      <div class="d-inline-block w-38">{{role.enableAll?'ON':'OFF'}}</div>-->
                      <!--<div class="d-inline custom-control custom-switch">
                        <input type="checkbox" name="onoffswitch1" class="custom-control-input" id="{{role?.groupId}}" [ngModelOptions]="{standalone: true}"   [(ngModel)]="role.enableAll" (change)="allStatusChange(role)">
                        <label class="custom-control-label" for="{{role?.groupId}}">
                        </label>
                      </div>-->
                      <div class="toggle-2">
                        <input type="checkbox" name="onoffswitch1" id="{{role?.groupId}}" class="checkbox"  [ngModelOptions]="{standalone: true}"   [(ngModel)]="role.enableAll"  (change)="allStatusChange(role)"/>
                        <label for="{{role?.groupId}}" class="toggle">
                          <span>ON</span><span>OFF</span>
                        </label>
                      </div>
                    </div>
                    <div class="col-lg-9 col-md-7 col-sm-7 " [ngClass]="{'text-dark-orange':role.enableAll}">
                      <label class="mb-0">Allow all access</label>
                    </div>
                  </div>
                  <hr class="my-2" *ngIf="['outbound_orders','inventory','work_orders','inbound_orders'].indexOf(role.groupCode)>-1">
                  <div class="row">
                    <div class="col-12 my-1" *ngFor="let action of role.securityTypes">
                      <div class="row align-items-center ">
                        <div class="col-lg-3 col-md-5 col-sm-5  text-center">
<!--                          <div class="d-inline-block w-38 pr-2">{{action.enabled?'ON':'OFF'}}</div>-->
                          <!--<div class="d-inline custom-control custom-switch">
                            <input type="checkbox" name="onoffswitch1" class="custom-control-input" id="{{action.securityTypeId}}" [ngModelOptions]="{standalone: true}"   [(ngModel)]="action.enabled" (change)="statusChange(action,role,i)">
                            <label class="custom-control-label" for="{{action.securityTypeId}}">
                            </label>
                          </div>-->
                          <div class="toggle-2">
                            <input type="checkbox" name="onoffswitch1" id="{{action.securityTypeId}}" class="checkbox"  [ngModelOptions]="{standalone: true}"   [(ngModel)]="action.enabled"  (change)="statusChange(action)"/>
                            <label for="{{action.securityTypeId}}" class="toggle">
                              <span>ON</span><span>OFF</span>
                            </label>
                          </div>
                          <!--                  <div class="custom-control custom-switch">-->
                          <!--                    <input type="checkbox"  class="custom-control-input" id="{{action.securityTypeId}}"  [ngModelOptions]="{standalone: true}"   [(ngModel)]="action.enabled" (change)="statusChange(action)">-->
                          <!--                    <label class="custom-control-label" for="{{action.securityTypeId}}"> </label>-->
                          <!--                  </div>-->
                        </div>
                        <div class="col-lg-9 col-md-7 col-sm-7" [ngClass]="{'text-dark-orange':action.status==='ACTIVE'}">
                          <label class="mb-0">{{action.securityName}}</label>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6 px-0">
            <div class="d-block  mt-2" *ngFor="let role of groupList | slice:sliceUPto(groupList?.length)-1:groupList?.length;let i = index;">
              <div class="col">
                <div class="inner-box">
                  <h2 class="text-black">{{role.groupDescription}}</h2>
                  <hr class="mt-1 mb-2">
                  <div class="row align-items-center" *ngIf="['outbound_orders','inventory','work_orders','inbound_orders'].indexOf(role.groupCode)>-1">
                    <div class="col-lg-3 col-md-5 col-sm-5  text-center">
<!--                      <div class="d-inline-block w-38">{{role.enableAll?'ON':'OFF'}}</div>-->
                      <!--<div class="d-inline custom-control custom-switch ">
                        <input type="checkbox" name="onoffswitch1" class="custom-control-input" id="{{role?.groupId}}" [ngModelOptions]="{standalone: true}"   [(ngModel)]="role.enableAll" (change)="allStatusChange(role)">
                        <label class="custom-control-label" for="{{role?.groupId}}">
                        </label>
                      </div>-->
                      <div class="toggle-2">
                        <input type="checkbox" name="onoffswitch1" id="{{role?.groupId}}" class="checkbox"  [ngModelOptions]="{standalone: true}"   [(ngModel)]="role.enableAll"  (change)="allStatusChange(role)"/>
                        <label for="{{role?.groupId}}" class="toggle">
                          <span>ON</span><span>OFF</span>
                        </label>
                      </div>
                    </div>
                    <div class="col-lg-9 col-md-7 col-sm-7" [ngClass]="{'text-dark-orange':role.enableAll}">
                      <label class="mb-0">Allow all access</label>
                    </div>
                  </div>
                  <hr class="my-2" *ngIf="['outbound_orders','inventory','work_orders','inbound_orders'].indexOf(role.groupCode)>-1">
                  <div class="row">
                    <div class="col-12 my-1" *ngFor="let action of role.securityTypes">
                      <div class="row align-items-center">
                        <div class="col-lg-3 col-md-5 col-sm-5  text-center">
<!--                          <div class="d-inline-block w-38">{{action.enabled?'ON':'OFF'}}</div>-->
                          <!--<div class="d-inline custom-control custom-switch">
                            <input type="checkbox" name="onoffswitch1" class="custom-control-input" id="{{action.securityTypeId}}" [ngModelOptions]="{standalone: true}"   [(ngModel)]="action.enabled" (change)="statusChange(action,role,i)">
                            <label class="custom-control-label" for="{{action.securityTypeId}}">
                            </label>
                          </div>-->
                          <div class="toggle-2">
                            <input type="checkbox" name="onoffswitch1" id="{{action.securityTypeId}}" class="checkbox"  [ngModelOptions]="{standalone: true}"   [(ngModel)]="action.enabled" (change)="statusChange(action)"/>
                            <label for="{{action.securityTypeId}}" class="toggle">
                              <span>ON</span><span>OFF</span>
                            </label>
                          </div>
                          <!--                  <div class="custom-control custom-switch">-->
                          <!--                    <input type="checkbox"  class="custom-control-input" id="{{action.securityTypeId}}"  [ngModelOptions]="{standalone: true}"   [(ngModel)]="action.enabled" (change)="statusChange(action)">-->
                          <!--                    <label class="custom-control-label" for="{{action.securityTypeId}}"> </label>-->
                          <!--                  </div>-->
                        </div>
                        <div class="col-lg-9 col-sm-7" [ngClass]="{'text-dark-orange':action.status==='ACTIVE'}">
                          <label class="mb-0">{{action.securityName}}</label>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
<!--
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <div class="row mt-3">
            <div class="col">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <select  id="invoiceType" class="form-control" [(ngModel)]="role.name" [ngModelOptions]="{standalone: true}" (click)="click()" >
                      <option  *ngFor="let i of auth" [ngValue]="i.name">{{i.name}}</option>
                    </select>
                    <label class="control-label" for="invoiceType"><b>Assign Roles</b></label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-8">
                  <table class="table">
                    <thead>
                    <tr>
                      <th class="control-label">Assigned Roles</th>
                      <th>Remove</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let r of selectedRoles">
                      <td>{{r.userRole}}</td>
                      <td>
                        <a (click)="removeProduct(r)">
                          <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                            <defs><style>.a{fill:#848484;}</style></defs>
                            <path class="a" d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z" transform="translate(-7.5 -4.5)"/>
                          </svg>
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
-->
  </form>
</section>
<div class="form-btn-section">
  <div class="row">
  <div class="col-12 text-right">
    <button type="reset" routerLink="/admin/myAccountList" class="btn btn-cancel">Cancel</button>
    <button type="submit" (click)="editUser()" class="btn btn-orange ml-3">Save</button>
  </div>
</div>
</div>
